import { DrakeFieldComponent } from 'app/drake-components/drake-field/drake-field.component';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild, ViewContainerRef, input } from '@angular/core';
import { CommonModule, DatePipe, JsonPipe } from '@angular/common';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DrakeGridComponent } from 'app/drake-components/drake-grid/drake-grid.component';
import { DrakeViewStandardComponent } from 'app/drake-components/drake-view-standard/drake-view-standard.component';
import { DrakeViewWizardComponent } from '../drake-view-wizard/drake-view-wizard.component';
import { DrakeViewKpiComponent } from '../drake-view-kpi/drake-view-kpi.component';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@ngneat/transloco';
import { DrakeTimelineComponent } from '../drake-timeline/drake-timeline.component';
import { DrakeTreeComponent } from '../drake-tree/drake-tree.component';
import { DrakeSocialViewComponent } from '../drake-social-view/drake-social-view.component';
import { ChangePasswordComponent } from '../drake-change-password/drake-change-password.component';
import { FormsModule } from '@angular/forms';
import { DrakeCalendarViewComponent } from '../drake-calendar-view/drake-calendar-view.component';
import { DrakeChartsComponent } from 'app/drake-dashboards/drake-chart/drake-chart.component';
import { DrakeQuickAddComponent } from '../drake-quick-add/drake-quick-add.component';
import { DrakeListViewComponent } from '../drake-listview/drake-listview.component';
import { environment } from 'environments/environment';
import { DrakeImagePreviewComponent } from '../drake-image-preview/drake-image-preview.component';
import { Router, RouterLink, RouterLinkActive, RouterModule } from '@angular/router';
import { SVGIcon, downloadIcon} from '@progress/kendo-svg-icons';
import { NgForOf } from '@angular/common';
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { AuthService } from 'app/core/auth/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';


@Component({ 
    selector: 'app-drake-custom-component',
    templateUrl: './drake-custom-component.component.html',
    styleUrls: ['./drake-custom-component.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, MatIconModule, TranslocoPipe, JsonPipe, RouterModule, ButtonsModule],
    providers:[JsonPipe, TranslocoPipe]
})
export class DrakeCustomComponentComponent implements AfterViewInit {
    @ViewChild('container', { read: ViewContainerRef })
    container: ViewContainerRef;
    public componentId: any = this.getRandomString(16);

    @Input() public config: any;
    @Input() public baseData: any;
    @Input() public pageData: any;
    @Input() public readonly: boolean = false;
    @Input() public mainRecord: any;
    @Input() public chartsId: string = "";
    @Output() public outputEvent = new EventEmitter<any>();
    public downloadSVG: SVGIcon = downloadIcon;
    

    validationState: any = {};

    constructor(private router:Router, private http: HttpClient, private authService:AuthService, private sanitizer:DomSanitizer) {

    }

    refresh(){

    }

    ngAfterViewInit(): void {
        let parentComponent = this;

        let componentConfig = parentComponent.config;
        let tsCode = parentComponent.config.componentTsCode;
        let myBaseData = parentComponent.baseData;
        let myReadOnly = parentComponent.readonly;
        let myValidationState = parentComponent.validationState;
        let myPageData = parentComponent.pageData;
        let match = /\#\w+\#/g.exec(tsCode);
        let myEnvironment = environment;
        let router = this.router;

        while (match != null) {
            tsCode = tsCode.replace(match[0], parentComponent.config.componentArgs[match[0].split('#')[1]]);
            match = /\#\w+\#/g.exec(tsCode);
        }

        const customComponent = Component({
            selector: 'drake-custom-component-' + this.config.componentCode.toLowerCase().replace('.', '-') + "-" + this.componentId,
            template: `
      <style type="text/css">
      ${this.config.componentCssCode}
      </style>
      <div style="height: ${this.config.componentShowHeader ? 'calc(100% - 2em)' : '100%'}">
      ${this.config.componentHtmlCode}
      </div>`,
            jit: true,
            standalone: true,
            providers: [JsonPipe,TranslocoPipe],
            outputs: [],
            inputs: ["config", "readonly", "mainRecord"],
            imports: [
                CommonModule,
                FormsModule,
                NgForOf,
                InputsModule,
                RouterModule,
                RouterLink, 
                DrakeGridComponent,
                DrakeFieldComponent,
                DrakeViewStandardComponent,
                DrakeViewKpiComponent,
                DrakeViewWizardComponent,
                DrakeTimelineComponent,
                DrakeChartsComponent,
                DrakeSocialViewComponent,
                ChangePasswordComponent,
                TranslocoPipe,
                DrakeTreeComponent,
                DrakeCalendarViewComponent,
                DrakeQuickAddComponent,
                DrakeListViewComponent,
                DrakeImagePreviewComponent,
                JsonPipe,
                TranslocoPipe,
                DatePipe
            ]
        })(class CustomComponent implements OnChanges {
            outputEvent = new EventEmitter<any>();
            public config: any = componentConfig;
            public drkComponent: any = {};
            public baseData: any = myBaseData;
            public readonly: any = myReadOnly;
            public validationState: any = myValidationState;
            public mainRecord: any = parentComponent.mainRecord;
            public chartsId: string = parentComponent.chartsId;
            public pageData: any = myPageData;
            public environment : any = myEnvironment;
            private urlParams = new URLSearchParams(window.location.search);
            public filter = this.decodeJSONString(this.urlParams.get('filter') || '{}');
            public sort = this.decodeJSONString(this.urlParams.get('sort') || '{}');
            public docFilesTagFilter;

            public authService = parentComponent.authService;
            public sanitizer = parentComponent.sanitizer;

            constructor() {

                eval(tsCode);
                var c = setInterval(_ => {
                    if (parentComponent.mainRecord && parentComponent.mainRecord._id) {
                        this.mainRecord = parentComponent.mainRecord;
                        clearInterval(c);
                    }
                }, 500);
            }
            ngOnChanges(changes: SimpleChanges): void {
                console.log('customComponent changes', changes);
                
            }

            onChange(ev) {
                //console.log("on change drake custom");
                
                this.outputEvent.emit(ev);
            }

            getDocFilesTagsFilter(dateFrom:string, dateTo:string, PnCodes:string){
                this.docFilesTagFilter = {
                    $and: [
                      { DateFrom: { $gte: new Date(dateFrom) } },
                      { DateTo: { $lte: new Date(dateTo) } },
                      { PartNumberCodes: PnCodes }
                    ]
                  };
                  
                var docFilesTagFilterString: string = JSON.stringify(this.docFilesTagFilter);
                return docFilesTagFilterString;
                  
            }

          
            decodeJSONString(str: string): string {
                try {
                const decodedStr = str.replace(/\\\"/g, '"');
                const parsedJSON = JSON.parse(decodedStr);
                return JSON.stringify(parsedJSON);
                } catch (e) {
                console.error('Invalid JSON string:', str);
                return '{}'; // Fallback to an empty object if parsing fails
                }
            }

        });

        const component = this.container.createComponent(customComponent);
        component.instance.outputEvent.subscribe((outData) => this.emitOutput(outData));

        //this.renderer.appendChild(this.container.element.nativeElement, component.location.nativeElement);
    }

    emitOutput(value: any) {
        //console.log("Emit output drake custom");

        this.outputEvent.emit(value);
    }

    getRandomString(length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        return result;
    }
    
}
